<template>
  <div>
    <div class="operation-btn" v-if="isHQ||isBU">
      <div>规则配置{{this.index+1}}</div>
      <el-popover
        popper-class="po-connect-popover"
        placement="right"
        width="230"
        trigger="click">
        <div class="popover-content" v-loading="loading">
          <div class="tree-box">
            <div class="btn-box" v-if="!noData">
              <el-button class="select-btn" size="mini" @click="selectAll(true)">全选</el-button>
              <el-button class="select-btn" size="mini" @click="selectAll(false)">全不选</el-button>
            </div>
            <el-tree
              :data="tree"
              :default-checked-keys="saveKey"
              ref="tree" 
              show-checkbox
              node-key="id"
              @check="handleCheckChange"
              :filter-node-method="filterNode"
              :props="defaultProps">
            </el-tree>
          </div>
          <!-- <el-button @click="handleConnect()" class="buttons" plain size="mini" type="primary">设置关联对象</el-button> -->
        </div>
        <div class="add-style" slot="reference" plain size="mini">
          配置可用区域
        </div>
      </el-popover>
      <div class="operate-style" @click="handleDelete()">删除</div>
    </div>
    <div>
      <span class="sp-el-form">
            <el-form-item v-if="igniteOptions.igniteStatus" class="ignite_item_select">
              <el-select class="item-select" multiple @change="(...arr) => handleSelectIgnite('igniteStatus', ...arr)"
                v-model="params.igniteStatus" placeholder="IGNITE状态(多选)" clearable>
                <el-option v-for="(key,value) in igniteOptions.igniteStatus" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="igniteOptions.openStatus" class="ignite_item_select">
              <el-select class="item-select" multiple @change="(...arr) => handleSelectIgnite('openStatus', ...arr)"
                v-model="params.openStatus" placeholder="售点状态(多选)" clearable>
                <el-option v-for="(key,value) in igniteOptions.openStatus" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="igniteOptions.channel" class="ignite_item_select">
              <el-select class="item-select" multiple @change="(...arr) => handleSelectIgnite('channel', ...arr)"
                v-model="params.channel" placeholder="渠道设置(多选)" clearable> 
                <el-option v-for="(key,value) in igniteOptions.channel" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="getBizForm()" class="ignite_item_select">
              <el-select class="item-select" multiple @change="(...arr) => handleSelectIgnite('bizForm', ...arr)"
                v-model="params.bizForm"  placeholder="业态(多选)" clearable>
                <el-option v-for="(key,value) in getBizForm()" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
              <!-- <el-cascader
                ref="test"
                v-model="params.bizForm"
                :options="getBizForm()"
                :props="props"
                clearable>
              </el-cascader> -->
            </el-form-item>
            <el-form-item v-if="igniteOptions.pocGrade" class="ignite_item_select" >
              <el-select class="item-select" multiple  @change="(...arr) => handleSelectIgnite('pocGrade', ...arr)"
                 v-model="params.pocGrade" placeholder="档次(多选)" clearable>
                <el-option v-for="(key,value) in igniteOptions.pocGrade" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item v-if="igniteOptions.salesVolume" class="ignite_item_select">
              <el-select class="item-select" multiple  @change="(...arr) => handleSelectIgnite('salesVolume', ...arr)"
                v-model="params.salesVolume" placeholder="销售潜力(多选)" clearable>
                <el-option v-for="(key,value) in igniteOptions.salesVolume" :key="value" :label="key" :value="value">
                </el-option>
              </el-select>
            </el-form-item> -->
          </span>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapState } from 'vuex'
export default {
  props: {
    baseConfig: { type: Object, default: () => { } },
    saveInfo:{ type: Object, default: () => { } },
    itemKey:{type:Number,default:0},
    index:{type:Number,default:0},
    treeData:{ type: Array, default: () => [] },
    saveKey:{ type: Array, default: () => [] },
  },
  data(){
    return {
      params:{},
      loading:false,
      tree:[],
      noData:true,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      isSelected:false,
      employeeLevel:0
    }
  },
  computed:{
     ...mapGetters(['userInfo']),
     ...mapState({
      igniteOptions: state => state.gameplan.igniteOptions
    }),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
    this.tree = this.treeData
  },
  mounted(){
    if(this.saveInfo&&Object.keys(this.saveInfo).length>0){
      this.params = this.saveInfo.igniteRuleObj
    }
    this.setSelectedStatus()
    this.$refs.tree&&this.$refs.tree.filter()
  },
  watch:{
    'tree' :{
      handler:function(){
        this.noData = true
        for(let item of this.tree){
        if(item.children&&item.children){
          item.children.forEach(child=>{
            if(child.selected===''||child.selected===this.itemKey){
              this.noData = false
            }
          })
        }else{
          if(item.selected===''||item.selected===this.itemKey){
            this.noData = false
          }
        }
      }
      },
      immediate:true,
      deep:true
    }
  },
  methods:{
    getBizForm(){
      switch (this.baseConfig.themeChannelCode) {
        case '01':
          return {'2022010103': "大排档",'2022010104': "火锅",'2022010105': "烧烤/小龙虾",'2022010106':"中式正餐",'2022010201': "夜总会",'2022010202': "KTV",'2022010203': "慢摇吧",'2022010204': "酒吧",'2022010205': "餐吧"}
        case '02':
          return {'2022010103': "大排档",'2022010104': "火锅",'2022010105': "烧烤/小龙虾",'2022010106':"中式正餐"}
        case '03':
          return {'2022010203': "慢摇吧"}
        case '04':
          return {'2022010201': "夜总会",'2022010202': "KTV"}
        case '05':
          return {'2022010204': "酒吧",'2022010205': "餐吧"}
        case '06':
          return {'2022010204': "酒吧",'2022010205': "餐吧"}
        case '07':
          return {'2022010102':"外国餐厅",'2022010204': "酒吧",'2022010205': "餐吧"}
        case '08':
          return {'2022010102':"外国餐厅",'2022010204': "酒吧",'2022010205': "餐吧"}
        case '09':
          return {'2022010102':"外国餐厅",'2022010204': "酒吧",'2022010205': "餐吧"}
        default:
          return {}
      }
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    // 点击提交按钮再提交bu和region的数据（现在暂时没用）
    // handleConnect(){
    //   let data = this.$refs.tree.getCheckedNodes(true)
    //   data.forEach(item=>{
    //     item.selected = this.itemKey
    //   })
    //   //this.handleDataToTree()
    //   //console.log(this.$refs.tree.getCheckedNodes(true));
    //   this.$emit("handleConnect",data,this.itemKey)
    // },
    filterNode(value, data, node){
      let showNode = false
      if(data.selected==''||data.selected==this.itemKey){
        showNode = true
      }
      return showNode
    },
    // 手动修改选择框展示图标：不选，全选，半选 
    //（某个父节点下的最后一个子节点被选中，则其他选中了该父节点的子节点的item，父节点的状态由半选改为全选）
    setSelectedStatus(){
      for(let item of this.treeData){
        let none = 0
        let selected = 0
        if(item.children){
          for(let region of item.children){
            region.selected===''&&none++
            region.selected===this.itemKey&&selected++
          }
          if(none===0||selected===0){
            this.$refs.tree.setChecked(item.id,none===0&&selected!==0)
          }else if(none!==0&&selected!==0){
            console.log(item);
            let node = this.$refs.tree.getNode(item.id)
            node.checked = false
            node.indeterminate = true
          }
        }
      }
      this.$refs.tree&&this.$refs.tree.filter()
    },
    handleCheckChange(data,obj){
      let isParent = data.children&&data.children.length>0
      let isClear = obj.checkedKeys.indexOf(data.id)===-1&&obj.halfCheckedKeys.indexOf(data.id)===-1
      // 如果点击父节点全选，但是部分子节点被其他item占用，手动将被占用的节点取消选中
      if(isParent&&!isClear){
        for(let regionItem of data.children){
          if(regionItem.selected!==''&&regionItem.selected!==this.itemKey){
            this.$refs.tree.setChecked(regionItem.id,false)
          }
        }
      }
      if(this.isHQ||this.isBU){
        // 直接将选中的所有id传过去不行，取消了某个节点后，父组件里不会将该节点的selected置空
        //this.$emit("handleConnect",obj.checkedKeys,this.itemKey,!all)
        this.$emit("handleConnect",data,this.itemKey,isClear,isParent)
      }
    },
    handleSelectIgnite(type,data){
      this.$emit("handleSelectIgnite",type,data,this.itemKey)
    },
    handleDelete(){
      let data = this.$refs.tree.getCheckedNodes(true)
      console.log(data);
      this.$emit("handleDeleteIgnite",data,this.itemKey)
    },
    selectAll(selected){
      let data = []
      for(let item of this.tree){
        if(item.children&&item.children){
          item.children.forEach(child=>{
            if(child.selected===''||child.selected===this.itemKey){
              this.$refs.tree.setChecked(child.id,selected)
              data.push(item)
            }
          })
          this.$emit("handleConnect",item,this.itemKey,!selected,true)
        }else{
          if(item.selected===''||item.selected===this.itemKey){
            this.$refs.tree.setChecked(item.id,selected)
            this.$emit("handleConnect",item,this.itemKey,!selected,false)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .el-popover{
  display: block;
  height: 360px !important;
  overflow: auto !important;
}
.tree-box{
  height: 295px;
  overflow-y: auto !important;
  overflow-x: hidden;
}
.buttons{
  margin-left: 130px;
  position: absolute;
}
.operation-btn{
  display: flex;
  height: 30px;
  text-align: center;
  align-items: center;
  width: 300px;
  justify-content: space-between;
}
.add-style{
  color: rgb(0, 145, 230);
  cursor: pointer;
}
.operate-style{
  color: rgb(238, 0, 0);
  cursor: pointer;
}
.btn-box{
  display: flex;
  margin-left: 110px;
}
</style>